<i18n>
{
    "fa": {
        "departingHour": "ساعت خروج",
        "arrivingHour": "ساعت ورود",
        "purchaseTicket": "خرید بلیط",
        "discountedPrice": "قیمت با ‌تخفیف ویژه"
    }
}
</i18n>

<template>
    <div class="promotion-banner">
        <div class="promotion-banner__badge w-normal">
            {{ $t('common.specialOffer') }}
        </div>
        <div class="promotion-banner__content flex flex-align-center">
            <div class="flex-1 flex px-1 flex-fill flex-align-center">
                <div class="pl-2 hidden-xs hidden-sm">
                    <img :src="banner.providerLogoPath" alt="" width="110">
                </div>
                <div>
                    <div class="w-500 font-20">
                        {{ banner.origin }}
                    </div>
                    <div :class="this.$device.desktop ? 'text-nowrap' : ''">
                        <span class="text-nowrap">
                            {{ $t('departingHour') }}:
                        </span>
                        <b class="text-blue w-500">
                            {{ banner.departureDateTime ? $moment(banner.departureDateTime).format('HH:mm') : ' - ' }}
                        </b>
                    </div>
                </div>

                <div class="flex-1 flex-fill text-center px-3">
                    <p class="m-0 small">
                        {{ banner.departureDateTime ? $moment(banner.departureDateTime).format('dddd jD jMMMM') : '' }}
                    </p>
                    <div class="line-circle my-2" />
                </div>

                <div>
                    <div class="w-500 font-20">
                        {{ banner.destination }}
                    </div>
                    <div :class="this.$device.desktop ? 'text-nowrap' : ''">
                        <span class="text-nowrap">
                            {{ $t('arrivingHour') }}:
                        </span>
                        <b class="text-blue w-500">
                            {{ banner.arrivalDateTime ? $moment(banner.arrivalDateTime).format('HH:mm') : ' - ' }}
                        </b>
                    </div>
                </div>
            </div>
        </div>
        <div class="promotion-banner__footer text-black">
            <span class="w-normal ml-auto hidden-xs hidden-sm px-2 text-ellipsis">
                {{ $t('discountedPrice') }} <span class="visible-lg-inline">{{ $t('common.websiteName') }}</span>
            </span>
            <span class="text-danger font-18 w-500 promotion-banner__off mr-auto ml-1">{{ banner.oldPrice | addCommas }}</span>
            <strong class="promotion-banner__price text-nowrap px-2">{{ banner.newPrice | addCommas }} <small class="w-normal">{{ $t('common.currencyT') }}</small></strong>
            <a class="btn btn-info w-500 py-1 px-3 font-14 mr-1" :href="banner.link" target="_blank">
                {{ $t('purchaseTicket') }}
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        banner: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss">
@import '~vars';

.promotion-banner {
    $alert: #BF0018; // stylelint-disable-line
    $primary: #FFC847; // stylelint-disable-line
    $success: #5EC726; // stylelint-disable-line
    position: relative;
    min-height: 150px;
    max-width: 576px;
    margin: 0 auto;

    &__side, &__footer {
        background-color: $primary;
        border: 1px solid $primary;
    }

    &__content {
        flex: 1;
        border: 1px solid $primary;
        padding: 15px;
    }

    &__badge {
        background-color: $alert;
        text-align: center;
        color: $snow-white;
        border-radius: 100px;
        font-size: 15px;
        line-height: 1.95em;
        display: inline-block;
        padding: 0 7px;
    }

    &__off {
        line-height: 1;
        color: $alert;
        position: relative;

        &::after {
            content: ' ';
            display: block;
            height: 1px;
            background-color: $alert;
            transform: rotate(-12deg);
            position: absolute;
            top: 50%;
            right: 0;
            left: 0;
        }
    }

    &__price {
        font-size: 20px;

        small {
            font-size: 0.65em;
        }

        @media (min-width: 768px) {
            font-size: 22px;
        }
    }

    .text-success {
        color: $success;
    }

    .vr {
        width: 1px;
        height: 100%;
        background-color: $gray-platinum;
        margin: 0 15px;
    }

    hr {
        border-color: $gray-platinum;
    }

    &--timer {
        display: flex;
        flex-wrap: wrap;

        .promotion-banner {

            &__side {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 4px 15px;
                font-size: 12px;
                line-height: 1.4em;
                border-radius: 5px 5px 0 0;

                .v-count-down-digit {
                    font-size: 15px;
                }

                p {
                    font-size: 12px;
                }
            }

            &__content {
                flex-wrap: wrap;
                border-radius: 0 0 5px 5px;
            }
        }

        @media (min-width: 768px) {
            flex-wrap: nowrap;

            .promotion-banner__side {
                display: block;
                width: 120px;
                border-radius: 0 5px 5px 0;
                padding: 6px;
            }

            .promotion-banner__content {
                flex-wrap: nowrap;
                border-radius: 5px 0 0 5px;
            }
        }
    }
}

.line-circle {
    width: 100%;
    height: 2px;
    background-color: $gray-light;
    position: relative;

    &::after, &::before {
        content: ' ';
        display: inline-block;
        border: 1px solid $gray-light;
        width: 10px;
        height: 10px;
        border-radius: 100%;
        background-color: $snow-white;
        position: absolute;
        left: 0;
        top: -4px;
    }

    &::after {
        left: auto;
        right: -5px;
    }
}
</style>

<style lang="scss" scoped>
.promotion-banner {

    &__badge {
        position: absolute;
        top: -12px;
        right: 5px;
        border-radius: 40px 40px 40px 0;
        font-size: 13px;
    }

    &__content {
        border-radius: 5px 5px 0 0;
        padding: 18px;
    }

    &__footer {
        display: flex;
        align-items: center;
        padding: 4px 6px;
        border-top: 0;
        border-radius: 0 0 5px 5px;
    }
}
</style>
